import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import React from "react";
import './dashboard.scss'
import hand from '../../../assets/hand.png'
import Events from "./events/events";
import StudentList from "./studentOverview/studentList";
import Notifications from "../../notifications/notifications";
import { useAppSelector } from "../../../store/hooks/hooks";

const Dashboard = () => {
    const userDetails = useAppSelector((state: any) => state.user.user.result)
    return (
        <div className="flex flex-row py-4 px-2 w-100 mob-flex-column">
            <div className="flex flex-column">
                <div className="flex justify-content-between mx-2">
                    <div className="align-items-start flex flex-row">
                        <h1 className="titleDashboard">Hi <span className="titleName">{userDetails.first_name} {userDetails.last_name}</span>,Good Morning</h1>
                        <img src={hand} className="imageHand m-2"></img>
                    </div>
                    <div className="align-items-baseline flex flex-row justify-content-between">
                        <Notifications></Notifications>
                    </div>
                </div>
                <div>
                    <StudentList></StudentList>
                </div>
            </div>
            <div className="borderShadow w-50 eventContainer">
                <Events></Events>
            </div>
        </div>
    )
}
export default Dashboard